import { wait } from './wait';

export const retry = async <T>(fn: () => T, retries = 20): Promise<T> => {
  const result = await fn();

  if (retries > 0 && !result) {
    await wait(200);
    return retry(fn, retries - 1);
  }

  return result;
};
